'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:InvoiceServiceCtrl
 * @description
 * # InvoiceCtrl
 * Service to contact invoices API
 */
angular.module('thothApp.services')
  .factory('Invoice', ['$http', 'domain', 'BaseService', 'toaster', function ($http, domain, BaseService, toaster) {
    var BASE_INVOICE_URL = domain.name + '/api/v1/invoices/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_INVOICE_URL,
      baseModelName: 'invoice'
    });

    baseService.sanitizeParams = function(invoice) {
      delete invoice.audited;
      delete invoice.permitted_events;
      return invoice;
    };

    baseService.findMissingPercentage = function(projectId) {
      return $http.get(BASE_INVOICE_URL + "percentage_to_invoice", { params: { project_id: projectId } });
    };

    baseService.error = function(error) {
      if(error && error.status === 422) {
        if('audit_comment' in error.data.errors) {
          toaster.pop('error', 'Comentario', 'El comentario ' + error.data.errors.audit_comment);
          error.data.errors = delete error.data.errors.audit_comment;
        }
        if('folio' in error.data.errors) {
          toaster.pop('error', 'Folio', error.data.errors.folio[0]);
          error.data.errors = delete error.data.errors.folio;
        }
        if('date_of_invoice' in error.data.errors) {
          toaster.pop('error', 'Fecha', error.data.errors.date_of_invoice[0]);
          error.data.errors = delete error.data.errors.date_of_invoice;
        }
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
